import { view } from '@/functions';

const prefix = '/leads';

export default [
    {
        path: prefix,
        name: 'leads',
        meta: {
            title: 'Leads',
            scopes: ['read_leads', 'write_leads', 'write_own_leads']
        },
        component: () => view('leads/index')
    },
    {
        path: `${prefix}/info`,
        name: 'leads-info',
        meta: {
            title: 'Leads',
            scopes: ['read_leads', 'write_leads', 'write_own_leads']
        },
        component: () => view('leads/info')
    },
    {
        path: `${prefix}/quote`,
        name: 'leads-quote',
        meta: {
            title: 'Cotización',
            scopes: ['read_leads', 'write_leads', 'write_own_quotes']
        },
        component: () => view('leads/quote')
    },
];
